import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import { ReceiveText } from '@/entities/conversation'
import Typography from '@/components/Rain/Typography/Typography.vue'
import ReviewCopyIcon from '@/assets/img/Icons/White/review-copy.svg'
import ReviewGoIcon from '@/assets/img/Icons/White/review-go.svg'
import ReviewGreenCheck from '@/assets/img/Icons/Green/review-check.svg'
import ReviewGreenExclamation from '@/assets/img/Icons/Green/review-exclamation.svg'
import { copyToClipboard } from '@/utils/function'
import { trackReviewLinkClicked } from '@/api/conversation'

interface Props {
    item: ReceiveText
    comment: string
    slug: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewLinkButton',
  props: {
    item: null,
    comment: null,
    slug: null
  },
  emits: ['load'],
  setup(__props: any, { emit }) {

const props = __props as { item: ReceiveText, comment: string, slug: string };

// customer face survey form component

ref(ReviewCopyIcon)
ref(ReviewGoIcon)

const showGoReviewButton = ref(false)
const countdownSeconds = ref(3)
const shortlinkSlug = ref('')

const defaultTitle =
    'Use the button below to copy your testimonial and take you to the Reviews page.'
const defaultBtnTitle = 'Copy Testimonial'
const requestTitle = ref(props.item.title || defaultTitle)
const btnTitle = ref(props.item.btnTitle || defaultBtnTitle)



onMounted(async () => {
    // As this ReviewLinkButton has no input, we need to trigger another next()
    // to mark response finished!!!!
    emit('load')
    const { data } = await trackReviewLinkClicked(
        props.slug,
        props.item.link,
        false
    )
    shortlinkSlug.value = data.linkSlug
})

const copyComment = (link: string | undefined) => {
    copyToClipboard(props.comment)
    showGoReviewButton.value = true

    const timer = setInterval(function () {
        if (countdownSeconds.value <= 1) {
            clearInterval(timer)
            visitReviewPage(link)
        }
        countdownSeconds.value--
    }, 1000)
}

const visitReviewPage = (link: string | undefined) => {
    window.open(link, '_blank')
    trackReviewLinkClicked(props.slug, link, true, shortlinkSlug.value)
}

return { __sfc: true,props, showGoReviewButton, countdownSeconds, shortlinkSlug, defaultTitle, defaultBtnTitle, requestTitle, btnTitle, emit, copyComment, visitReviewPage, Typography, ReviewCopyIcon, ReviewGoIcon, ReviewGreenCheck, ReviewGreenExclamation }
}

})